<i class="{{ iconClass() }}"></i> {{ message() }}